import groq from "groq";

/**
 * Office-owned neighborhood list for the Neighborhoods (Automatic) block.
 * Catalog lives on `office.neighborhoods` (Location). Hub `routeSlug` comes
 * from the neighborhood’s route node (no home-care-service context), not from
 * a slug field on the neighborhood document.
 *
 * Hub route data is scoped to this office’s service-area branch root so shared
 * neighborhood documents cannot resolve another office’s hub slug.
 */
const NeighborhoodsByOfficeIdQuery = groq`
  *[_type == "office" && _id == $officeId][0].neighborhoods[]->{
    _id,
    _type,
    name,
    "hubRoute": *[
      _type == "routeNode" &&
      isEnabled == true &&
      defined(page._ref) &&
      ^._id in context[_type == "neighborhoodRef"]._ref &&
      count(context[_type == "homeCareServiceRef"]) == 0 &&
      parent._ref == "routeNode-service-area-" + string(*[_type == "office" && _id == $officeId][0].officeID)
    ][0]{
      "routeSlug": slug.current,
      "serviceAreaBranchSlug": parent->slug.current
    }
  }
`;

export { NeighborhoodsByOfficeIdQuery };
